import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=3c9c1ca3&scoped=true&"
var script = {}
import style0 from "./translate.vue?vue&type=style&index=0&id=3c9c1ca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c1ca3",
  null
  
)

export default component.exports